// extracted by mini-css-extract-plugin
module.exports = {"label":"Radio_label__EXBi9","input":"Radio_input__ZbPJr"};